/**
 * session storage 操作
 */
export default {
    setItem(key, data) {
        try {
            sessionStorage.setItem(key, JSON.stringify(data));
        }
        catch (e) {
            return '';
        }
    },
    getItem(key) {
        try {
            return JSON.parse(sessionStorage.getItem(key) || '');
        }
        catch (e) {
            return '';
        }
    },
    removeItem(key) {
        sessionStorage.removeItem(key);
    },
};
